
import { supabase } from '../integrations/supabase/client';

// Get the current origin for redirect URLs
const getOrigin = () => {
  // In development, use the dev server URL
  // In production, use the current origin (which should be your custom domain)
  return window.location.origin;
};

// Login with email/password
export const handleLogin = async (email: string, password: string) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    
    if (error) throw error;
    return data.user;
  } catch (error: any) {
    console.error('Error logging in:', error.message);
    throw error;
  }
};

// Sign up
export const handleSignUp = async (email: string, password: string) => {
  try {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: `${getOrigin()}/auth/callback`,
      },
    });
    
    if (error) throw error;
    return data;
  } catch (error: any) {
    console.error('Error signing up:', error.message);
    throw error;
  }
};

// Google Sign-in
export const handleGoogleSignIn = async () => {
  try {
    console.log('Initiating Google sign-in...');
    
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${getOrigin()}/auth/callback`,
        queryParams: {
          access_type: 'offline',
          prompt: 'consent',
        },
      },
    });
    
    if (error) {
      console.error('Google OAuth error:', error);
      throw error;
    }
    
    console.log('Google sign-in initiated successfully');
    return data;
  } catch (error: any) {
    console.error('Error with Google sign-in:', error);
    
    // Provide more specific error messages for common OAuth issues
    if (error.message?.includes('403') || error.status === 403) {
      throw new Error('Google authentication failed. Please check your browser settings and try again.');
    } else if (error.message?.includes('popup')) {
      throw new Error('Please allow popups for this site and try again.');
    } else {
      throw new Error(`Google sign-in failed: ${error.message || 'Unknown error'}`);
    }
  }
};

// Discord Sign-in
export const handleDiscordSignIn = async () => {
  try {
    console.log('Initiating Discord sign-in...');
    
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'discord',
      options: {
        redirectTo: `${getOrigin()}/auth/callback`,
      },
    });
    
    if (error) {
      console.error('Discord OAuth error:', error);
      throw error;
    }
    
    console.log('Discord sign-in initiated successfully');
    return data;
  } catch (error: any) {
    console.error('Error with Discord sign-in:', error);
    
    // Provide more specific error messages for common OAuth issues
    if (error.message?.includes('403') || error.status === 403) {
      throw new Error('Discord authentication failed. Please check your browser settings and try again.');
    } else if (error.message?.includes('popup')) {
      throw new Error('Please allow popups for this site and try again.');
    } else {
      throw new Error(`Discord sign-in failed: ${error.message || 'Unknown error'}`);
    }
  }
};

// Logout
export const handleLogout = async () => {
  try {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  } catch (error: any) {
    console.error('Error logging out:', error.message);
    throw error;
  }
};
